import React, { useState } from 'react';
import { useTranslation } from 'next-i18next';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import RequestForm from '../organisms/RequestForm';
import CtaBox from '../molecules/CtaBox';
import styles from '../../styles/components/organisms/ItemFooter.module.scss';

interface ItemFooterProps {
  data: any;
  type: string;
  access?: boolean;
  claimed?: boolean;
  claim?: () => void;
  setLayer: (obj: any) => void;
  referer?: string;
}

const ItemFooter = (props: ItemFooterProps) => {
  const { data, type, access, claim, setLayer } = props;
  const { t } = useTranslation(['common', 'venue', 'service']);
  const { id, plan } = data;

  return (
    <>
      <Row>
        <Col xs={8}>
          {access ? (
            <CtaBox
              type={'rocket'}
              h2={t(`${type}:ready-to-publish`)}
              label={t(`${type}:cta-publish`)}
              icon={type}
              href={(() => {
                // if (
                //   type === 'service' &&
                //   data.maximum_cities < (data.cities?.length || 1)
                // ) {
                //   return `/service-provider-package?service_provider_id=${id}`;
                // }
                // if (plan !== 'BASIC') {
                //   return `/venue-packages?venue_id=${id}`;
                // }

                return '/my-businesses';
              })()}
            />
          ) : !!claim ? (
            <CtaBox
              type={`${type}s`}
              h2={t(`${type}:ready-to-claim`)}
              p={t(`${type}:claim-info`)}
              label={t(`${type}:cta-claim`)}
              icon={type}
              onClick={claim}
            />
          ) : (
            <CtaBox
              type="proposal"
              h2={t(`${type}:proposal`)}
              label={t(`${type}:cta-proposal`)}
              onClick={() =>
                setLayer({
                  bg: true,
                  large: true,
                  children: (
                    <RequestForm
                      type={type}
                      data={data}
                      onSubmit={() => setLayer(undefined)}
                    />
                  ),
                })
              }
            />
          )}
        </Col>
      </Row>
    </>
  );
};

export default ItemFooter;
